import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import BlogCat from '../components/layouts/Blog/BlogCat'
import BlogLatest from '../components/layouts/Blog/BlogLatest'
import BlogDetailComments from '../components/layouts/BlogDetail/BlogDetailComments'
import BlogDetailHeader from '../components/layouts/BlogDetail/BlogDetailHeader'
import BlogDetailRate from '../components/layouts/BlogDetail/BlogDetailRate'
import BlogDetailTag from '../components/layouts/BlogDetail/BlogDetailTag'
import useFetch from '../hooks/useAxios'

const BlogDetail = () => {
  const [BLogInfo, setBLogInfo] = useState([]); 
  
  const apiGetBlog = useFetch({
    method: "get",
    url: "api/posts",
    noHeader: true,
    trigger: true,
    argFunc: res => setBLogInfo(res.data.posts)
  });
  const [BLogDetail, setBLogDetail] = useState(); 
  const {id,slug}=useParams()
  const apiGetBlogDetail = useFetch({
    method: "get",
    url: `api/posts/sh/${slug}`,
    noHeader: true,
    trigger: true,
    argFunc: res => setBLogInfo(res.data)
  });
  return (
   <div>
      {!apiGetBlogDetail.loading && !apiGetBlog.loading && <div className="container">
      <div className="Blog-grid mt-[40px]">
        <div className="">
          <BlogCat BLogInfo={BLogInfo}/>
          <BlogLatest   BLogInfo={BLogInfo}/>
        </div>
        <div>
          <div className="BlogDetail-container">
             <BlogDetailHeader/>
             <BlogDetailTag />
             <BlogDetailRate />
             <BlogDetailComments/>
          </div>
        </div>
      </div>
    </div>}
   </div>
  )
}

export default BlogDetail